import React, { Fragment, useEffect, useState } from "react";
import Humberg from "../../elements/Humberg.jsx";
import DefaultConfigurations from "./DefaultConfigurations.jsx";
import Categories from "./Categories.jsx";
import ProductTypes from "./ProductTypes.jsx";
import ProductMarkets from "./ProductMarket.jsx";

const SystemConfiguration = () => {
    const [activeTab, setActiveTab] = useState("settings");

    useEffect(() => {
        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const subLinks = document.querySelectorAll(".subLinks");
        const element = document.getElementById("dashboard")
        const subElement = document.getElementById("system-configuration");

        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        subLinks.forEach(el => el.classList.remove("activeSubLink"));
        element?.classList.add("activeHeaderLink");
        subElement?.classList.add("activeSubLink");

        document.title = `System Configuration`;
    }, []);

    const tabs = [
        { id: "settings", label: "General Settings", icon: "fa-cog" },
        { id: "categories", label: "Categories", icon: "fa-list-ul" },
        { id: "markets", label: "Product Markets", icon: "fa-globe" },
        { id: "types", label: "Product Types", icon: "fa-layer-group" }
    ];

    return (
        <Fragment>
            <Humberg header="Dashboard" headerLink="/" children={"System Configuration"} />
            
            <section className="p-2 lg:p-8 min-h-screen bg-gray-50/50">
                <div className="w-full max-w-7xl mx-auto">
                    {/* Page Header */}
                    <div className="mb-4 lg:mb-8 px-2">
                        <h1 className="text-xl lg:text-3xl font-bold text-gray-800">System Configuration</h1>
                        <p className="text-gray-500 mt-1 text-xs lg:text-base">Manage portal settings and classifications.</p>
                    </div>

                    {/* Tabs Navigation */}
                    <div className="flex overflow-x-auto no-scrollbar gap-1 mb-4 p-1 bg-gray-100/80 rounded-xl w-full lg:w-fit">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`flex items-center justify-center gap-2 px-4 lg:px-6 py-2.5 lg:py-3 rounded-lg text-[10px] lg:text-sm font-bold transition-all duration-300 flex-1 lg:flex-none whitespace-nowrap
                                    ${activeTab === tab.id 
                                        ? "bg-white text-indigo-600 shadow-sm" 
                                        : "text-gray-500 hover:text-gray-700 hover:bg-white/50"}`}
                            >
                                <i className={`fa-solid ${tab.icon} text-xs lg:text-sm`}></i>
                                <span>{tab.label}</span>
                            </button>
                        ))}
                    </div>

                    {/* Content Area */}
                    <div className="bg-white rounded-xl lg:rounded-2xl shadow-xl shadow-gray-200/50 border border-gray-100 overflow-hidden">
                        <div className="p-4 lg:p-10">
                            {activeTab === "settings" && (
                                <div className="animate-fadeIn">
                                    <div className="flex items-center gap-3 mb-6 lg:mb-8 pb-3 lg:pb-4 border-b border-gray-100">
                                        <div className="w-8 h-8 lg:w-10 lg:h-10 rounded-lg bg-indigo-50 flex items-center justify-center text-indigo-600">
                                            <i className="fa-solid fa-cog text-sm lg:text-lg"></i>
                                        </div>
                                        <div>
                                            <h2 className="text-base lg:text-xl font-bold text-gray-800">General Configuration</h2>
                                            <p className="hidden lg:block text-xs text-gray-500 font-medium">Global rates and default instruction sets</p>
                                        </div>
                                    </div>
                                    <DefaultConfigurations />
                                </div>
                            )}

                            {activeTab === "categories" && (
                                <div className="animate-fadeIn">
                                    <div className="flex items-center gap-3 mb-6 lg:mb-8 pb-3 lg:pb-4 border-b border-gray-100">
                                        <div className="w-8 h-8 lg:w-10 lg:h-10 rounded-lg bg-emerald-50 flex items-center justify-center text-emerald-600">
                                            <i className="fa-solid fa-list-ul text-sm lg:text-lg"></i>
                                        </div>
                                        <div>
                                            <h2 className="text-base lg:text-xl font-bold text-gray-800">Category Management</h2>
                                            <p className="hidden lg:block text-xs text-gray-500 font-medium">Define and organize product categories</p>
                                        </div>
                                    </div>
                                    <Categories />
                                </div>
                            )}

                            {activeTab === "markets" && (
                                <div className="animate-fadeIn">
                                    <div className="flex items-center gap-3 mb-6 lg:mb-8 pb-3 lg:pb-4 border-b border-gray-100">
                                        <div className="w-8 h-8 lg:w-10 lg:h-10 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600">
                                            <i className="fa-solid fa-globe text-sm lg:text-lg"></i>
                                        </div>
                                        <div>
                                            <h2 className="text-base lg:text-xl font-bold text-gray-800">Market Destinations</h2>
                                            <p className="hidden lg:block text-xs text-gray-500 font-medium">Configure active product markets and countries</p>
                                        </div>
                                    </div>
                                    <ProductMarkets />
                                </div>
                            )}

                            {activeTab === "types" && (
                                <div className="animate-fadeIn">
                                    <div className="flex items-center gap-3 mb-6 lg:mb-8 pb-3 lg:pb-4 border-b border-gray-100">
                                        <div className="w-8 h-8 lg:w-10 lg:h-10 rounded-lg bg-purple-50 flex items-center justify-center text-purple-600">
                                            <i className="fa-solid fa-layer-group text-sm lg:text-lg"></i>
                                        </div>
                                        <div>
                                            <h2 className="text-base lg:text-xl font-bold text-gray-800">Product Classifications</h2>
                                            <p className="hidden lg:block text-xs text-gray-500 font-medium">Setup specific product types and commissions</p>
                                        </div>
                                    </div>
                                    <ProductTypes />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            <style jsx>{`
                .no-scrollbar::-webkit-scrollbar {
                    display: none;
                }
                .no-scrollbar {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .animate-fadeIn {
                    animation: fadeIn 0.4s ease-out forwards;
                }
            `}</style>
        </Fragment>
    );
};

export default SystemConfiguration;
